import type { DogDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/pet';
import {
    getCoverageTermValue,
    formatAmountToDK,
    formatAmountWithCurrency,
    isCoverageSelected
} from '../coverableDetailsInsuranceSumsConfig';
import ViewHippoInformationModal from '../../../../shared_components/ViewHippoInformationModal/ViewHippoInformationModal';
import { type TableInformation } from '../../../../config/flavourConfig';

const getDogInsuranceSumsCoverableDetailsConfig = (dogCoverable: DogDTO): TableInformation => {
    return {
        title: 'Forsikringssummer',
        rowsInformation: [
            {
                name: 'Ansvar ved skade på personer',
                fieldValue: formatAmountWithCurrency(
                    formatAmountToDK(
                        getCoverageTermValue(
                            dogCoverable,
                            'PETLiabilityCov',
                            'PETLiabilityCovPersonSum'
                        )
                    )
                ),
                valueType: 'amount',
                hidden: !isCoverageSelected(dogCoverable, 'PETLiabilityCov'),
                categoryType: 'category1'
            },
            {
                name: 'Ansvar ved skade på dyr og ting',
                fieldValue: formatAmountWithCurrency(
                    formatAmountToDK(
                        getCoverageTermValue(
                            dogCoverable,
                            'PETLiabilityCov',
                            'PETLiabilityCovAnimalSum'
                        )
                    )
                ),
                valueType: 'amount',
                hidden: !isCoverageSelected(dogCoverable, 'PETLiabilityCov'),
                categoryType: 'category1'
            },
            {
                name: 'Udgifter til dyrlægeregninger pr. forsikringsår',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(dogCoverable, 'PETHealthCov', 'PETHealthCovOptSum')
                ),
                valueType: 'amount',
                hidden: !isCoverageSelected(dogCoverable, 'PETHealthCov'),
                categoryType: 'category2'
            },
            {
                key: 'PETHealthCovWaitingPeriod',
                name: 'Karensperiode',
                fieldValue: `${getCoverageTermValue(
                    dogCoverable,
                    'PETHealthCov',
                    'PETHealthCovWaitingPeriod'
                )} dage`,
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-DOG-MODAL-HEALTH-WAITING-PERIOD-TITLE',
                        description: 'DSS-DOG-MODAL-HEALTH-WAITING-PERIOD-DESCRIPTION'
                    }
                },
                hidden: !isCoverageSelected(dogCoverable, 'PETHealthCov'),
                categoryType: 'category2'
            },
            {
                name: 'Forsikringssum nedtrappes, når hunden er',
                fieldValue:
                    getCoverageTermValue(
                        dogCoverable,
                        'PETHealthCov',
                        'PETHealthSicknessReductionAgeDog'
                    ).split('.')[0] + ' år',
                valueType: 'amount',
                hidden: !isCoverageSelected(dogCoverable, 'PETHealthCov'),
                categoryType: 'category2'
            },
            {
                name: 'Genoptræning',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        dogCoverable,
                        'PETHealthPlusCov',
                        'PETHealthPlusCovOptRehabSum'
                    )
                ),
                valueType: 'amount',
                hidden: !isCoverageSelected(dogCoverable, 'PETHealthPlusCov'),
                categoryType: 'category3'
            },
            {
                name: 'Udleveret receptmedicin',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        dogCoverable,
                        'PETHealthPlusCov',
                        'PETHealthPlusCovOptMedicineSum'
                    )
                ),
                valueType: 'amount',
                hidden: !isCoverageSelected(dogCoverable, 'PETHealthPlusCov'),
                categoryType: 'category3'
            },
            {
                name: 'Udbetaling ved død/aflivning',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(dogCoverable, 'PETLifeCov', 'PETLifeCovSum')
                ),
                labelType: 'modalLink',
                valueType: 'amount',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-DOG-MODAL-HEALTH-TITLE',
                        description: 'DSS-DOG-MODAL-HEALTH-DESCRIPTION'
                    }
                },
                hidden: !isCoverageSelected(dogCoverable, 'PETLifeCov'),
                categoryType: 'category4'
            },
            {
                key: 'PETLifeCovWaitingPeriod',
                name: 'Karensperiode',
                fieldValue: `${getCoverageTermValue(
                    dogCoverable,
                    'PETLifeCov',
                    'PETLifeCovWaitingPeriod'
                )} dage`,
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-DOG-MODAL-LIFE-WAITING-PERIOD-TITLE',
                        description: 'DSS-DOG-MODAL-LIFE-WAITING-PERIOD-DESCRIPTION'
                    }
                },
                hidden: !isCoverageSelected(dogCoverable, 'PETLifeCov'),
                categoryType: 'category4'
            }
        ]
    };
};

export { getDogInsuranceSumsCoverableDetailsConfig };
